
    import "src/app/AppWms/Catalog/utils.module.scss?farm_css_modules";
    
    export default {"buttonRightMargin": `buttonRightMargin-3ee04439`,"searchFilter": `searchFilter-3ee04439`,"searchInput": `searchInput-3ee04439`,"topFilter": `topFilter-3ee04439`,"topLeftFilter": `topLeftFilter-3ee04439`}
    